export default __webpack_public_path__ + "ebdb35f77210278bfd30921597d524eb.svg";